var React = require('react');

function CircleActiveInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"10","cy":"10","r":"9","stroke":"#269C74","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"10","cy":"10","r":"1","stroke":"#269C74","strokeWidth":"3","key":1})]));
}

CircleActiveInline.defaultProps = {"width":"20","height":"20"};

module.exports = CircleActiveInline;

CircleActiveInline.default = CircleActiveInline;
